import { render, staticRenderFns } from "./Form_StaffReviewer.vue?vue&type=template&id=75765b06&scoped=true"
import script from "./Form_StaffReviewer.vue?vue&type=script&lang=js"
export * from "./Form_StaffReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75765b06",
  null
  
)

export default component.exports